<a className={className} href={link} onClick={onClick}>
  <span className="hidden">{publisher}</span>
</a>



/** WEBPACK FOOTER **
 ** ./htmls/share-button.html
 **/